import { Injectable, inject } from '@angular/core';
import {
  Auth,
  GoogleAuthProvider,
  User,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  updatePassword,
  confirmPasswordReset,
} from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  private auth: Auth = inject(Auth);

  async googleLogin() {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(this.auth, provider);
  }

  async sendPasswordResetEmail(email: string) {
    return sendPasswordResetEmail(this.auth, email);
  }

  async firebaseCreateUser(email: string, password: string) {
    return createUserWithEmailAndPassword(this.auth, email, password);
  }

  async updatePassword(newPassword: string) {
    const user = this.auth.currentUser;
    if (user) {
      return updatePassword(user, newPassword);
    }
    throw new Error('No user is currently signed in');
  }

  async firebaseLogin(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  async fetchSignInMethodsForEmail(email: string): Promise<string[]> {
    try {
      return await fetchSignInMethodsForEmail(this.auth, email);
    } catch (error) {
      console.error('Error fetching sign-in methods:', error);
      throw error;
    }
  }

  async confirmPasswordReset(code: string, newPassword: string) {
    const auth = getAuth();
    return confirmPasswordReset(auth, code, newPassword);
  }

  // Add auth state listener if needed
  getAuthState() {
    return this.auth;
  }
}
